import { FC } from "react";
import { useLocation } from "react-router-dom";
import { IHeaderPage } from "../../../interfaces/components/HeaderPage.types";
import { cx } from "../../../utils/classnames";
import VideoPopup from "../../ui/OpenVideoTutModal";
import HeaderActions from "./HeaderActions";
import HeaderDateRange from "./HeaderDateRange";
import Filters from "./HeaderFilters";

const PageHeader: FC<IHeaderPage> = ({
  link,
  hasFilter,
  hasNoInput,
  filterName,
  options,
  filterSelctor,
  videoTutorial,
  querySelector,
  dateFromSelector,
  dateToSelector
}) => {
  const { pathname } = useLocation();

  return (
    <div className={cx(["mb-4 flex md:flex-row gap-3 md:gap-0 justify-between items-start first-letter",
      videoTutorial ? "flex-col" : "flex-row"
    ])}>
      <div className="flex">
      {link && <HeaderActions {...link} />}
      {videoTutorial ? (
        <VideoPopup link={videoTutorial?.link} title={videoTutorial?.title} />
      ) : null}
      </div>
      <div className=" w-full flex flex-[2] justify-end">
        {pathname === "/office" && (
          <HeaderDateRange
            dateFromSelector={dateFromSelector}
            dateToSelector={dateToSelector}
          />
        )}
        <Filters
          hasNoInput={hasNoInput}
          hasFilter={hasFilter}
          filterName={filterName}
          options={options}
          filterSelctor={filterSelctor}
          querySelector={querySelector}
        />
      </div>
    </div>
  );
};

export default PageHeader;
